import {Svg} from "@/shared/ui/Svg";
import styles from "./Video.module.scss";

type Props = {
    muted: boolean;
    onClick: () => void;
};

export const VolumeButton = ({muted, onClick}: Props) => (
    <div className={styles.volume} onClick={onClick}>
        <Svg id={muted ? "volumeOff" : "volumeOn"} className={muted ? styles.volumeOff : styles.volumeOn} />
    </div>
);
